export const defaultTimeWindow = {
    displayValue: "",
    hideAggregation: false,
    hideAggInterval: false,
    hideTimeZone: false,
    selectedTab: 0,
    realTime: {
        realTimeType: 0,
        interval: 300000,
        timeWindowMs: 86400000,
        quickInterval: "CURRENT_DAY",
        hideInterval: false,
        hideLastInterval: false,
        hideQuickInterval: false
    },
    history:{
        historyType: 0,
        interval: 1000,
        timeWindowMs: 60000,
        quickInterval: "CURRENT_DAY",
        hideInterval: false,
        hideLastInterval: false,
        hideFixedInterval: false,
        hideQuickInterval: false,
        fixedTimeWindow:{
            startTimeMs: 1752218152157,
            endTimeMs: 1752304552157
        }
    },
    aggregation:{
        type: "AVG",
        limit: 25000
    }
};